import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import Select from 'react-select'
import DatePicker from "react-datepicker";
import moment from "moment-timezone";

export default function AdsNamingCreativeBoostpostCreate() {
    const roles = new Role();
    let userId = roles.loginUserId;

    //region duplicate
    let adsNamingId = null;
    let {encode} = useParams();
    if(encode) {
        let decode = Utils.decodeItem(encode);
        adsNamingId = decode.id;
    }
    //endregion

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [pillar, setPillar] = React.useState('');
    let [pillarId, setPillarId] = React.useState(null);
    let [owner, setOwner] = React.useState('');
    let [ownerId, setOwnerId] = React.useState(null);
    let [content, setContent] = React.useState('');
    let [contentId, setContentId] = React.useState(null);
    let [contentDate, setContentDate] = React.useState('');
    let [preview, setPreview] = React.useState('');
    const navigate = useNavigate();

    React.useEffect(() => {
        (async function() {
            try {
                const resPillar = await getPillar();
                setPillar(resPillar);
                const resOwner = await Utils.getOwner({agencyId: roles.agencyId});
                setOwner(resOwner);
                //region duplicate
                if(adsNamingId) {
                    const resView = await getView(adsNamingId);
                    setPillarId(resView.pillar);
                    if(resView.ownerData) {
                        setOwnerId(resView.ownerData);
                    }
                    if(resView.contentDate) {
                        setContentDate(new Date(resView.contentDate));
                    }
                    if(resView.content) {
                        resView.content.name = Utils.contentIdGenerater(resView.content);
                        setContentId(resView.content);
                    }

                    setPreview(resView.params);
                }
                //endregion
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    //region duplicate
    async function getView(id) {
        const response = await fetch(Config.url.API_URL +'/api/adsNamingCreativeBoostpost/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }
    //endregion

    async function getPillar() {
        const response = await fetch(Config.url.API_URL +'/api/adsNamingContentPillar/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getPillarView(id) {
        const response = await fetch(Config.url.API_URL +'/api/adsNamingContentPillar/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getContentView(id) {
        const response = await fetch(Config.url.API_URL +'/api/contentId/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCreate = () => {
        if(!pillarId) {
            toast.error("กรุณาระบุ Content Pillar");
        }
        else if(!ownerId) {
            toast.error("กรุณาระบุ Owner");
        }
        else if(!contentId) {
            toast.error("กรุณาระบุ Content ID");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setLoading(true);

                            let pillarView = await getPillarView(pillarId.id);
                            let contentView = await getContentView(contentId.id);
                            let contentIdText = Utils.contentIdGenerater(contentView);
                            let params = pillarView.name + '_' + Utils.contentIdGenerater(contentView) + '_[ST]';

                            const body = {
                                adsNamingContentPillarId: pillarId.id,
                                adsNamingContentPillarText: pillarView.name,
                                ownerId: ownerId.id,
                                contentId: contentId.id,
                                contentIdText: contentIdText,
                                contentDate: contentDate ? new Date(contentDate) : null,
                                params: params,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            fetch(Config.url.API_URL +'/api/adsNamingCreativeBoostpost/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/adsNamingCreativeBoostpost', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeOwnerId = async (obj) => {
        setOwnerId(obj);
        setContent('');
        setContentId(null);
        if(obj && obj.id) {
            const resContent = await Utils.getContentId({ownerId: obj.id, postDate: contentDate ?? null});
            setContent(resContent);
        }
    };

    const onChangeContentId = async (obj) => {
        let params = '';
        setContentId(obj);
        let pillarView = await getPillarView(pillarId.id);
        let contentIdText = '';
        if(obj && obj.id) {
            let contentView = await getContentView(obj.id);
            contentIdText = Utils.contentIdGenerater(contentView);
            params = pillarView.name + '_' + contentIdText + '_[ST]';
        }
        setPreview(params);
    };

    const onChangeContentDate = async (value) => {
        setContentDate(value);
        setContentId(null);
        setContent('');
        setContentId(null);
        if(ownerId && ownerId.id && value) {
            const resContent = await Utils.getContentId({ownerId: ownerId ? ownerId.id : null, postDate: value});
            setContent(resContent);
        }
    };

    const onChangePillarId = async (obj) => {
        let params = '';
        setPillarId(obj);
        let pillarView = await getPillarView(obj.id);
        let contentIdText = '';
        if(contentId && contentId.id) {
            let contentView = await getContentView(contentId.id);
            contentIdText = Utils.contentIdGenerater(contentView);
            params = pillarView.name + '_' + contentIdText + '_[ST]';
        }
        setPreview(params);
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Creative Naming</div>
                    <span className="ms-1">/</span> <span className="text-muted">Content</span>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="pillarId" className="form-label">Content Pillar <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={pillar}
                                    onChange={(event) => onChangePillarId(event)}
                                    value={pillarId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="ownerId" className="form-label">Owner <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={owner}
                                    onChange={(event) => onChangeOwnerId(event)}
                                    value={ownerId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="contentDate" className="form-label">Content Date</label>
                                <DatePicker
                                    selected={contentDate}
                                    onChange={(date) => onChangeContentDate(date)}
                                    dateFormat="yyyy-MM-dd"
                                    wrapperClassName="w-100"
                                    className="form-control" />
                            </div>
                            <div className="col-12">
                                <label htmlFor="ownerId" className="form-label">Content ID <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={content}
                                    onChange={(event) => onChangeContentId(event)}
                                    value={contentId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${Utils.contentIdGenerater(option)}`}
                                />
                            </div>
                            <div className="col-12 p-3 mt-4">
                                <div className="row border rounded bg-green-light py-2">
                                    <div className="col-12">
                                        <label htmlFor="preview" className="form-label">Preview</label>
                                        <div className="noselect-url w100 rounded">{preview}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/adsNamingCreativeBoostpost'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 